import { Injectable } from '@angular/core';
import { Ptransaction } from '../../model/ptransaction';
import { Transaction } from '../../model/transaction';

@Injectable({
  providedIn: 'root',
})
export class PeriodicTransactionsManager {
  constructor() {}

  needsAddStaticTransactions(periodicTransaction: Ptransaction): boolean {
    if (periodicTransaction.updated === 0) return true;
    if (periodicTransaction.updated > periodicTransaction.endAt) return false;
    else {
      const today = new Date();
      const time0 = new Date(
        `${today.getMonth() + 1}/${today.getDate()}/${today.getFullYear()}`
      ).getTime();
      const nextDate = this.calculateNext(
        periodicTransaction.each,
        periodicTransaction.updated
      );

      return time0 >= nextDate.getTime();
    }
  }

  generateTransactions(
    periodicTransaction: Ptransaction,
    until
  ): Transaction[] {
    const limit = new Date(until).getTime();
    let begining =
      periodicTransaction.updated === 0
        ? periodicTransaction.startAt
        : periodicTransaction.updated;
    const arrayOfTransactions: Transaction[] = [];
    let iteration = 1;
    while (begining <= limit) {
      let transaction: Transaction;

      transaction = {
        id: (limit + iteration).toString(),
        date: new Date(begining).getTime(),
        amount: periodicTransaction.amount,
        description: periodicTransaction.description,
        category: periodicTransaction.category,
        owner: periodicTransaction.owner,
        periodicTransaction: periodicTransaction.id,
      };
      arrayOfTransactions.push(transaction);
      begining = this.calculateNext(
        periodicTransaction.each,
        begining
      ).getTime();
      iteration++;
    }
    return arrayOfTransactions;
  }

  calculateNext(each, baseDate) {
    baseDate = new Date(baseDate);
    const day = 86400000;
    let minimunTime;
    switch (each) {
      case 1:
        minimunTime = 1 * day;
        return new Date(baseDate.getTime() + minimunTime);
      case 2:
        minimunTime = 2 * day;
        return new Date(baseDate.getTime() + minimunTime);
      case 7:
        minimunTime = 7 * day;
        return new Date(baseDate.getTime() + minimunTime);
      case 14:
        minimunTime = 14 * day;
        return new Date(baseDate.getTime() + minimunTime);
      case 30:
        return new Date(
          `${
            baseDate.getMonth() + 2 < 13 ? baseDate.getMonth() + 2 : 1
          }/${baseDate.getDate()}/${
            baseDate.getMonth() + 2 < 13
              ? baseDate.getFullYear()
              : baseDate.getFullYear() + 1
          }`
        );
      case 60:
        return new Date(
          `${
            baseDate.getMonth() + 3
          }/${baseDate.getDate()}/${baseDate.getFullYear()}`
        );
      case 90:
        return new Date(
          `${
            baseDate.getMonth() + 4
          }/${baseDate.getDate()}/${baseDate.getFullYear()}`
        );
      case 120:
        return new Date(
          `${
            baseDate.getMonth() + 5
          }/${baseDate.getDate()}/${baseDate.getFullYear()}`
        );
      case 180:
        return new Date(
          `${
            baseDate.getMonth() + 7
          }/${baseDate.getDate()}/${baseDate.getFullYear()}`
        );
      case 365:
        return new Date(
          `${baseDate.getMonth() + 1}/${baseDate.getDate()}/${
            baseDate.getFullYear() + 1
          }`
        );
      default:
        return new Date();
    }
  }

  editPtransaction(
    periodicTransaction: Ptransaction,
    transactions: Transaction[]
  ) {
    const filteredTransactions = this.getTransactions(
      periodicTransaction,
      transactions
    );
    filteredTransactions.forEach((transaction) => {
      transaction.amount = periodicTransaction.amount;
      transaction.category = periodicTransaction.category;
      transaction.description = periodicTransaction.description;
    });

    return filteredTransactions;
  }

  getTransactions(
    periodicTransaction: Ptransaction,
    transactions: Transaction[]
  ) {
    const filteredTransactions = transactions.filter(
      (transaction) =>
        transaction.periodicTransaction === periodicTransaction.id
    );
    return filteredTransactions;
  }
}
